import { normaliseOrderMethodList } from '../../../services/helpers/OrderMethodAliases';

/**
 * What the Order Methods form saves (PROD-825 review). See
 * tests/views/order-settings/takeout/takeoutPayload.test.js.
 */

/** Whether two lists of order methods name the same methods, in any order and under either name. */
export function sameOrderMethods(a, b) {
  const left = new Set(normaliseOrderMethodList(a ?? []));
  const right = new Set(normaliseOrderMethodList(b ?? []));

  return left.size === right.size && [...left].every((method) => right.has(method));
}

/**
 * The form as it is saved: `hidden_order_methods` only when it differs from the list the form was
 * seeded with (or last saved). Left out, the backend keeps the stored list, so a tab opened before
 * someone changed it can't put the old one back.
 */
export function takeoutSettingsPayload(data, savedHiddenOrderMethods) {
  if (!data || !('hidden_order_methods' in data)) {
    return data;
  }

  const { hidden_order_methods: hiddenOrderMethods, ...rest } = data;

  if (sameOrderMethods(hiddenOrderMethods, savedHiddenOrderMethods)) {
    return rest;
  }

  return { ...rest, hidden_order_methods: normaliseOrderMethodList(hiddenOrderMethods) };
}
